import { BuyerBriefDrawer, NewBuyerBriefDrawer } from '@fiverr-private/brief_preview_drawer';
import { useInitialProps } from '../../context';

export const useBriefDrawer = () => {
  const { rollouts } = useInitialProps();
  const inMustangsPersonBriefRollout = rollouts?.inMustangsPersonBrief || false;

  return inMustangsPersonBriefRollout ? NewBuyerBriefDrawer : BuyerBriefDrawer;
};
